import { ClaimDetails } from '../models/claimListModel';
import * as types from '../types/claimListTypes';

const initialState: ClaimDetails = {
    claimDetails: [],
};

const claimDetailReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case types.FETCH_CLAIMS_LIST:
            return{
                ...state,
                claimDetails: Array.from(action.claimDetails),
            };
        default:
            return state;
    }
};

export default claimDetailReducer;
